import i18nFactory from '@yandex-int/i18n';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { ValidationErrorType, ValidationResult } from '../../typings/common';
import { CurrencyLimitData } from '../../typings/constants';
import { CurrencyCode } from '../../typings/graphql-grid';
import { parseNumber } from '../FormatHelpers/FormatHelpers';

import * as keyset from './PhraseMoneyCell.i18n';

const i18n = i18nFactory(keyset);

export function validatePhraseBid(
    value: string,
    priceLimit: Partial<CurrencyLimitData>,
    currency?: CurrencyCode | string
): ValidationResult {
    const { minPrice, maxPrice } = priceLimit;

    const errors = [];
    const num = parseNumber(value);

    if (value === undefined) {
        errors.push({
            text: i18n('emptyMessage'),
            type: ValidationErrorType.empty,
            path: 'value'
        });
    } else {
        if (isNaN(num)) {
            errors.push({
                text: i18n('nanMessage'),
                type: ValidationErrorType.nan,
                path: 'value'
            });
        }

        // если не заданы максимум и минимум - все хорошо
        if (minPrice === undefined || maxPrice === undefined) {
            return { valid: true };
        }

        if (num < minPrice) {
            const lteI18NCode = currency
                ? 'lteMessageWithCurrency'
                : 'lteMessage';
            errors.push({
                text: i18n(lteI18NCode, {
                    minValue: minPrice,
                    currency: mapStringToCurrencySymbol(
                        currency ? currency : CurrencyCode.RUB
                    )
                }),
                type: ValidationErrorType.lte,
                path: 'value'
            });
        }
        if (num > maxPrice) {
            const gteI18NCode = currency
                ? 'gteMessageWithCurrency'
                : 'gteMessage';
            errors.push({
                text: i18n(gteI18NCode, {
                    maxValue: maxPrice,
                    currency: mapStringToCurrencySymbol(
                        currency ? currency : CurrencyCode.RUB
                    )
                }),
                type: ValidationErrorType.gte,
                path: 'value'
            });
        }
    }

    return errors.length
        ? {
              valid: false,
              errors
          }
        : {
              valid: true
          };
}

export function validateCpmBannerPhraseBid(
    value: string,
    priceLimit: Partial<CurrencyLimitData>,
    currency?: CurrencyCode | string
): ValidationResult {
    const { minCpmPrice, maxCpmPrice } = priceLimit;

    const errors = [];
    const num = parseNumber(value);

    if (value === undefined) {
        errors.push({
            text: i18n('emptyMessage'),
            type: ValidationErrorType.empty,
            path: 'value'
        });
    } else {
        if (isNaN(num)) {
            errors.push({
                text: i18n('nanCpmBannerMessage'),
                type: ValidationErrorType.nan,
                path: 'value'
            });
        }

        if (minCpmPrice === undefined || maxCpmPrice === undefined) {
            return { valid: true };
        }

        if (num < minCpmPrice) {
            const lteI18NCode = currency
                ? 'lteCpmBannerMessageWithCurrency'
                : 'lteCpmBannerMessage';
            errors.push({
                text: i18n(lteI18NCode, {
                    minValue: minCpmPrice,
                    currency: mapStringToCurrencySymbol(
                        currency ? currency : CurrencyCode.RUB
                    )
                }),
                type: ValidationErrorType.lte,
                path: 'value'
            });
        }
        if (num > maxCpmPrice) {
            const gteI18NCode = currency
                ? 'gteCpmBannerMessageWithCurrency'
                : 'gteCpmBannerMessage';
            errors.push({
                text: i18n(gteI18NCode, {
                    maxValue: maxCpmPrice,
                    currency: mapStringToCurrencySymbol(
                        currency ? currency : CurrencyCode.RUB
                    )
                }),
                type: ValidationErrorType.gte,
                path: 'value'
            });
        }
    }

    return errors.length
        ? {
              valid: false,
              errors
          }
        : {
              valid: true
          };
}
